// src/features/recruitment/Recruitment.js
import React, { useState, useEffect } from "react";
import "./Recruitment.css";
import RecruitmentPipeline from "./RecruitmentPipeline";
import RecruitmentList from "./RecruitmentList";
import AddRecruitment from "./AddRecruitment";
import { VscChevronRight, VscChevronLeft } from "react-icons/vsc";
import config from "../../config";
import { MdArrowBackIos } from "react-icons/md";
import Header from "../../components/common/Header";
import { MdArrowBackIos as BackIcon } from "react-icons/md";


const Recruitment = ({ setActivePage }) => {
  // which main tab is selected in the white card tabs
  const [activeMainTab, setActiveMainTab] = useState("pipeline"); // "pipeline" | "list"

  // which sub-view is visible for content + header
  const [activeSubView, setActiveSubView] = useState("pipeline"); // "pipeline" | "list" | "add"

  // logged-in user info
  const [userDetails, setUserDetails] = useState({
    name: "",
    role: "",
    token: "",
  });

  // currently selected recruitment (for edit/view in AddRecruitment)
  const [selectedRecruitment, setSelectedRecruitment] = useState(null);

  // optional error message (for debugging / toast later)
  const [errorMsg, setErrorMsg] = useState("");

  const handleBack = () => {
  console.log("BACK CLICKED");
  setActiveSubView("list");
  setActiveMainTab("list");
  setSelectedRecruitment(null);
};

  useEffect(() => {
    const token = localStorage.getItem("Authorization") || "";
    const firstName = localStorage.getItem("firstName") || "";
    const lastName = localStorage.getItem("lastName") || "";
    const role = localStorage.getItem("role")?.toUpperCase() || "ADMIN";

    setUserDetails({
      name: `${firstName} ${lastName}`.trim(),
      role: role || "ADMIN",
      token,
    });
  }, []);

  // compute header title based on subview
  const headerTitle =
    activeSubView === "pipeline" ? (
      "Recruitment Pipeline"
    ) : activeSubView === "list" ? (
      "Recruitment List"
    ) : selectedRecruitment ? (
      "Edit Recruitment"
    ) : (
      "Add Recruitment"
    );

  const headerSubtitle =
    activeSubView === "pipeline" || activeSubView === "list" ? (
      <span>Recruitment Information</span>
    ) : (
      <span>
        All Recruitment <VscChevronRight className='breadcrumb-icon' /> {selectedRecruitment ? "Edit Recruitment" : "Add Recruitment"}
      </span>
    );

  // 👇 Called by RecruitmentList when user clicks a row
  const handleViewRecruitment = async (id) => {
    try {
      setErrorMsg("");

      if (!id) {
        console.warn("No recruitment id provided to handleViewRecruitment");
        return;
      }
      if (!userDetails.token) {
        console.warn("No token available for recruitment GET");
        return;
      }

      const url = `${config.API_BASE_URL}${config.RECRUITMENT_LIST_ENDPOINT}/${id}`;
      console.log("Fetching recruitment details:", url);

      const res = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${userDetails.token}`,
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      if (!res.ok) {
        const text = await res.text();
        console.error("Recruitment details error:", text);
        setErrorMsg("Could not load recruitment details.");
        return;
      }

      // ❗ validate response type
      const contentType = res.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        const text = await res.text();
        console.error("Non-JSON response received:", text);
        setErrorMsg("Invalid server response.");
        return;
      }

      const data = await res.json();
      console.log("Recruitment details response:", data);

      // Save selection and open AddRecruitment in edit mode
      setSelectedRecruitment(data);
      setActiveSubView("add");
      setActiveMainTab("list"); // visually stay on List tab
    } catch (err) {
      console.error("Recruitment details fetch exception:", err);
      setErrorMsg("Could not load recruitment details.");
    }
  };

  return (
    <div>
      {/* Header bar */}
      <Header 
        title={headerTitle} 
        subtitle={headerSubtitle} 
        onProfileClick={() => setActivePage && setActivePage("Profile")}
      >
        {activeSubView === "add" && (
          <button className='back-pill' onClick={handleBack}>
            <BackIcon size={19} />
          </button>
        )}
      </Header>

      {/* (Optional) simple error display – you can style or remove later */}
      {errorMsg && (
        <div style={{ color: "red", margin: "8px 24px" }}>{errorMsg}</div>
      )}

      {/* White card body */}
      <div className='recruitment-card'>
        {activeSubView === "pipeline" && (
          <RecruitmentPipeline
            activeMainTab={activeMainTab}
            setActiveMainTab={(tabName) => {
              setActiveMainTab(tabName);
              setActiveSubView(tabName); // keep subView in sync
            }}
          />
        )}

        {activeSubView === "list" && (
          <RecruitmentList
            activeMainTab={activeMainTab}
            setActiveMainTab={(tabName) => {
              setActiveMainTab(tabName);
              setActiveSubView(tabName); // keep subView in sync
            }}
            onAddRecruitment={() => {
              setSelectedRecruitment(null); // fresh form
              setActiveSubView("add");
              setActiveMainTab("list");
            }}
            onViewRecruitment={handleViewRecruitment} // 👈 row click handler
          />
        )}

        {activeSubView === "add" && (
  <AddRecruitment
    selectedRecruitment={selectedRecruitment}
    onCancel={handleBack}   // 👈 THIS MUST BE THERE
  />
)}
      </div>
    </div>
  );
};

export default Recruitment;
